__turbopack_context__.v({
  "app_light_theme": "Tabs-module-scss-module__GCl_WW__app_light_theme",
  "business": "Tabs-module-scss-module__GCl_WW__business",
  "business__active": "Tabs-module-scss-module__GCl_WW__business__active",
  "container": "Tabs-module-scss-module__GCl_WW__container",
  "regular": "Tabs-module-scss-module__GCl_WW__regular",
  "regular__active": "Tabs-module-scss-module__GCl_WW__regular__active",
  "tabs": "Tabs-module-scss-module__GCl_WW__tabs",
});
